module.exports = __webpack_public_path__ + "img/badge_gray_ihe-finance.366825b8.svg";